import {errorMessage} from 'shared/actions/notifications';
import browserHistory from 'shared/history';
import {SESSION_STORAGE_KEY} from 'src/components/Survey/constants';
import SurveyResponseService from 'src/services/SurveyResponseService';

export const onSubmit = (values) => (dispatch) =>
  SurveyResponseService.create(values)
    .then(() => {
      browserHistory.push('/scholarships');
      window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
    })
    .catch((error) => {
      console.error(error);
      dispatch(errorMessage());
    });
